/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  DocumentAnnotationResponse,
  ErrorObjectArray,
  ForbiddenErrorObject,
  PutApiV5FirmsDocumentsDocumentUuidAnnotationBody
} from '.././schemas'
import getApiV5FirmsDocumentsDocumentUuidAnnotationMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FirmsDocumentsDocumentUuidAnnotationErrorType } from '../../configOrvalAPIV5';
import putApiV5FirmsDocumentsDocumentUuidAnnotationMutator from '../../configOrvalAPIV5';
import type { ErrorType as PutApiV5FirmsDocumentsDocumentUuidAnnotationErrorType } from '../../configOrvalAPIV5';



/**
 * @summary Show Document Annotations
 */
export const getApiV5FirmsDocumentsDocumentUuidAnnotation = (
    documentUuid: string,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FirmsDocumentsDocumentUuidAnnotationMutator<DocumentAnnotationResponse>(
      {url: `/api/v5/firms/documents/${documentUuid}/annotation`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryKey = (documentUuid: string,) => {
    return [`/api/v5/firms/documents/${documentUuid}/annotation`] as const;
    }

    
export const getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError = GetApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>>(documentUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryKey(documentUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>> = ({ signal }) => getApiV5FirmsDocumentsDocumentUuidAnnotation(documentUuid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(documentUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FirmsDocumentsDocumentUuidAnnotationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>>
export type GetApiV5FirmsDocumentsDocumentUuidAnnotationQueryError = GetApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>


/**
 * @summary Show Document Annotations
 */

export function useGetApiV5FirmsDocumentsDocumentUuidAnnotation<TData = Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError = GetApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>>(
 documentUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FirmsDocumentsDocumentUuidAnnotationQueryOptions(documentUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update Document Annotations
 */
export const putApiV5FirmsDocumentsDocumentUuidAnnotation = (
    documentUuid: string,
    putApiV5FirmsDocumentsDocumentUuidAnnotationBody: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody,
 ) => {
      
      
      return putApiV5FirmsDocumentsDocumentUuidAnnotationMutator<DocumentAnnotationResponse>(
      {url: `/api/v5/firms/documents/${documentUuid}/annotation`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putApiV5FirmsDocumentsDocumentUuidAnnotationBody
    },
      );
    }
  


export const getPutApiV5FirmsDocumentsDocumentUuidAnnotationMutationOptions = <TError = PutApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>, {documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody}> = (props) => {
          const {documentUuid,data} = props ?? {};

          return  putApiV5FirmsDocumentsDocumentUuidAnnotation(documentUuid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV5FirmsDocumentsDocumentUuidAnnotationMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>>
    export type PutApiV5FirmsDocumentsDocumentUuidAnnotationMutationBody = PutApiV5FirmsDocumentsDocumentUuidAnnotationBody
    export type PutApiV5FirmsDocumentsDocumentUuidAnnotationMutationError = PutApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>

    /**
 * @summary Update Document Annotations
 */
export const usePutApiV5FirmsDocumentsDocumentUuidAnnotation = <TError = PutApiV5FirmsDocumentsDocumentUuidAnnotationErrorType<ForbiddenErrorObject | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>, TError,{documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiV5FirmsDocumentsDocumentUuidAnnotation>>,
        TError,
        {documentUuid: string;data: PutApiV5FirmsDocumentsDocumentUuidAnnotationBody},
        TContext
      > => {

      const mutationOptions = getPutApiV5FirmsDocumentsDocumentUuidAnnotationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    